/* eslint-disable jira/filename-case */
export const isCMDBEnabledInEnvironment = (): boolean => true;
